import { NgOptimizedImage } from '@angular/common'
import { Component, Signal, inject, ChangeDetectionStrategy, input } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { MatButtonModule } from '@angular/material/button'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { RouterModule } from '@angular/router'
import { AuthService, IdToken } from '@auth0/auth0-angular'

/**
 * Was die App ueber die angemeldete Person weiss. Kommt aus dem Backend der App (Profil), nicht
 * aus Auth0: das Auth0-Bild war nur ein Gravatar-Platzhalter und lief mit dem gespeicherten
 * auseinander.
 */
export interface ProfilWidgetDaten {
  readonly name: string
  readonly email: string
  readonly initialen: string
  /** Bereits aufgeloeste Bild-URL (Object-URL), `null` = Initialen. */
  readonly bildUrl: string | null
}

/**
 * Knopf rechts in der Kopfleiste mit dem Menue „Profil bearbeiten · Passwort ändern · Abmelden“.
 *
 * Mit `profil` (Leistungserbringer-App) zeigt der Knopf Bild oder Initialen und das Menue oben Name
 * und Adresse, damit man sieht, als wer man angemeldet ist. Ohne (interne Webapp) bleibt es beim
 * Bild aus dem Auth0-Token.
 */
@Component({
  selector: 'lib-profile-widget',
  imports: [NgOptimizedImage, RouterModule, MatButtonModule, MatIconModule, MatMenuModule, MatDialogModule],
  templateUrl: './profile-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './profile-widget.component.scss',
})
export class ProfileWidgetComponent {
  readonly dialog = inject(MatDialog)
  readonly auth = inject(AuthService)

  readonly profil = input<ProfilWidgetDaten | null>(null)

  readonly claim: Signal<IdToken | undefined | null>

  constructor() {
    this.claim = toSignal(this.auth.idTokenClaims$)
  }

  logout() {
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } })
  }
}
